import './printPackage.css'

import React, { useEffect, useState } from 'react'
import { Button, Form } from 'react-bootstrap'

import printIcon from '../../../imgs/printer.png'
import { getPackageById, getPackageByTrackingNumberInTurkey, getPackageByXlt } from '../../../services/packages'
import Sticker from '../Sticker/Sticker.jsx'

export default function PrintPackage() {
  const [packageStr, setPackageStr] = useState('')
  const [objForSticker, setobjForSticker] = useState({})
  const [isPrinting, setisPrinting] = useState(false)

  useEffect(() => {
    if (window.location.href.includes('office')) {
      document.getElementById('enable-toolbar').style.display = 'none'
    }
  }, [])

  const getPackageData = async obj => {
    let package_data
    try {
      if (obj.id) {
        package_data = await getPackageById(obj.id)
      } else if (obj.xlt) {
        package_data = await getPackageByXlt(obj.xlt)
      } else if (obj.trackingNumber) {
        package_data = await getPackageByTrackingNumberInTurkey(obj.trackingNumber)
      } else return
    } catch (error) {
      const msg = error.response?.data?.msg || error.response?.data?.error || error
      alert(msg)
      return
    }
    if (!package_data) {
      alert('Package not found!')
      return
    }

    let ordered = ''
    //check for multiple getPackageByTrackingNumberInTurkey packages return.
    if (obj.trackingNumber && package_data.length > 1) {
      alert('Pay Attention! \n There are more than one package. \n Showing all of them but you can print only the FIRST one!')
      package_data.forEach((p, idx) => {
        ordered +=
          `, ----- Package #${idx + 1} ----- ,` +
          JSON.stringify(
            Object.keys(p)
              .sort()
              .reduce((obj, key) => {
                obj[key] = p[key]
                return obj
              }, {})
          )
      })
    } else {
      const p = package_data
      ordered = JSON.stringify(
        Object.keys(p)
          .sort()
          .reduce((obj, key) => {
            obj[key] = p[key]
            return obj
          }, {})
      )
    }

    setPackageStr(ordered)
    setobjForSticker({
      unit: package_data.unit,
      trackingNumberToIsrael: package_data.trackingNumberToIsrael,
      name: package_data.costumer_firstName + ' ' + package_data.costumer_LastName,
      brand: package_data.brand,
      address:
        package_data.shippingAdress_adress +
        ' ' +
        package_data.shippingAdress_apartmentNumber +
        ' ' +
        package_data.shippingAdress_city +
        ' ' +
        package_data.shippingAdress_postalCode,
    })
  }

  const reset = () => {
    setPackageStr({})
    setobjForSticker({})
    document.getElementById('print-xlt-input').value = ''
    document.getElementById('print-id-input').value = ''
  }

  return (
    <section className='print-cmp'>
      {!isPrinting ? (
        <>
          <div className='print-action-cont'>
            <Button style={{ backgroundColor: '#f76767' }} variant='light' onClick={() => reset()}>
              Reset
            </Button>
            <div className='print-inputs-cont'>
              <div className='print-action'>
                <span style={{ marginRight: '10px' }}>Search by Package ID: </span>
                <div>
                  <Form.Control size='sm' id='print-id-input'></Form.Control>
                </div>
                <Button
                  style={{ backgroundColor: 'lightblue' }}
                  variant='light'
                  onClick={() =>
                    getPackageData({
                      id: document.getElementById('print-id-input').value,
                    })
                  }
                >
                  Search
                </Button>
              </div>

              <div className='print-action'>
                <span style={{ marginRight: '10px' }}>Search by XLT Number: </span>
                <div>
                  <Form.Control size='sm' id='print-xlt-input'></Form.Control>
                </div>
                <Button
                  style={{ backgroundColor: 'lightblue' }}
                  variant='light'
                  onClick={() =>
                    getPackageData({
                      xlt: document.getElementById('print-xlt-input').value,
                    })
                  }
                >
                  Search
                </Button>
              </div>
            </div>

            <div className='print-action'>
              <span style={{ marginRight: '10px' }}>Search by Turkey Tracking Number: </span>
              <div>
                <Form.Control size='sm' id='print-tracking-input'></Form.Control>
              </div>
              <Button
                style={{ backgroundColor: 'lightblue' }}
                variant='light'
                onClick={() =>
                  getPackageData({
                    trackingNumber: document.getElementById('print-tracking-input').value,
                  })
                }
              >
                Search
              </Button>
            </div>

            <div className='print-print'>
              <img
                src={printIcon}
                onClick={() => {
                  setisPrinting(true)
                }}
              />
            </div>
          </div>

          {packageStr.split(',').map((row, idx) => {
            return (
              <div className='print-card' key={idx}>
                <span> {row} </span>
              </div>
            )
          })}
        </>
      ) : (
        <Sticker data={objForSticker} />
      )}
    </section>
  )
}
